export const convertToPercentage = (val?: number) => {
  if (val === undefined) return undefined

  return +(val * 100).toFixed(4)
}
